/* Kayuri "Para ti": rellena el espacio personal con la Section Rendering API (kayuri-pt-items).
   Todo gira alrededor de los intereses del cliente: categorías de lo que compró y de lo que ha mirado. */
(function () {
  var SECTION = 'kayuri-pt-items';
  var VIEWED_KEY = 'kayuri:viewed';
  var SKELETONS = 4;
  var cache = {};

  function readViewed() {
    try {
      var list = JSON.parse(localStorage.getItem(VIEWED_KEY) || '[]');
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string' && h; }).slice(0, 12) : [];
    } catch (e) {
      return [];
    }
  }

  function withSection(url) {
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + SECTION;
  }

  // Devuelve el HTML de cada tarjeta (se guarda en caché para poder reutilizarlas en varios bloques).
  function fetchHtml(url) {
    if (!cache[url]) {
      cache[url] = fetch(withSection(url), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return [];
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return Array.prototype.map.call(doc.querySelectorAll('.pt-card'), function (c) { return c.outerHTML; });
        })
        .catch(function () { return []; });
    }
    return cache[url];
  }

  function toNodes(htmlList) {
    var tpl = document.createElement('template');
    tpl.innerHTML = htmlList.join('');
    return Array.prototype.slice.call(tpl.content.children);
  }

  function fetchCards(url) {
    return fetchHtml(url).then(toNodes);
  }

  // Peticiones de 3 en 3 para no saturar la tienda.
  function inBatches(urls, size) {
    var results = [];
    var i = 0;
    function next() {
      if (i >= urls.length) return Promise.resolve(results);
      var chunk = urls.slice(i, i + size);
      i += size;
      return Promise.all(chunk.map(fetchCards)).then(function (lists) {
        results = results.concat(lists);
        return next();
      });
    }
    return next();
  }

  function uniqueCards(lists, exclude, max) {
    var seen = {};
    (exclude || []).forEach(function (id) { seen[String(id)] = true; });
    var out = [];
    lists.forEach(function (list) {
      list.forEach(function (card) {
        var id = card.getAttribute('data-product-id');
        if (!id || seen[id] || out.length >= max) return;
        seen[id] = true;
        out.push(card);
      });
    });
    return out;
  }

  function interleave(lists) {
    var out = [];
    var longest = lists.reduce(function (m, l) { return Math.max(m, l.length); }, 0);
    for (var i = 0; i < longest; i++) {
      lists.forEach(function (l) { if (l[i]) out.push(l[i]); });
    }
    return [out];
  }

  function skeletons(n) {
    var frag = document.createDocumentFragment();
    for (var i = 0; i < n; i++) {
      var s = document.createElement('div');
      s.className = 'pt-card pt-card--skeleton';
      s.setAttribute('aria-hidden', 'true');
      s.innerHTML = '<div class="pt-card__media"></div><span></span><span></span>';
      frag.appendChild(s);
    }
    return frag;
  }

  function showSkeleton(row) {
    var track = row.querySelector('.pt-track');
    if (track) track.replaceChildren(skeletons(SKELETONS));
    row.setAttribute('aria-busy', 'true');
    row.hidden = false;
  }

  function animateIn(nodes) {
    nodes.forEach(function (n, i) {
      n.style.setProperty('--i', Math.min(i, 6));
      n.classList.add('is-in');
    });
  }

  function fill(row, cards) {
    row.removeAttribute('aria-busy');
    if (!cards.length) {
      row.hidden = true;
      return false;
    }
    var track = row.querySelector('.pt-track');
    animateIn(cards);
    track.replaceChildren.apply(track, cards);
    row.hidden = false;
    setupArrows(row);
    return true;
  }

  function setDesc(el, text) {
    var d = el.querySelector('.pt-head__desc');
    if (!d || !text) return;
    d.textContent = text;
    d.hidden = false;
  }

  function setupArrows(row) {
    var track = row.querySelector('.pt-track');
    var prev = row.querySelector('.pt-arrow[data-dir="-1"]');
    var next = row.querySelector('.pt-arrow[data-dir="1"]');
    if (!track || !prev || !next) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
      row.classList.toggle('pt-row--static', max <= 0);
      row.classList.toggle('is-end', track.scrollLeft >= max);
    }
    [prev, next].forEach(function (btn) {
      btn.onclick = function () {
        var dir = Number(btn.getAttribute('data-dir'));
        track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' });
      };
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  // Quita tildes y plurales sencillos para comparar palabras («Sofás» ≈ «sofá» ≈ «sofas»).
  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }
  function stems(text) {
    return norm(text)
      .split(/[^a-z0-9ñ]+/)
      .filter(function (w) { return w.length >= 4 && ['para', 'con', 'como', 'tienda'].indexOf(w) === -1; })
      .map(function (w) { return w.replace(/(es|s)$/, ''); });
  }

  function readInterests() {
    try {
      var v = JSON.parse(localStorage.getItem('kayuri:interests') || '{}');
      return v && typeof v === 'object' ? v : {};
    } catch (e) {
      return {};
    }
  }
  function readList(key) {
    try {
      var v = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(v) ? v.filter(function (x) { return typeof x === 'string' && x; }) : [];
    } catch (e) {
      return [];
    }
  }

  function joinWords(parts) {
    if (parts.length < 2) return parts.join('');
    return parts.slice(0, -1).join(', ') + ' y ' + parts[parts.length - 1];
  }

  // Motivo legible de un interés: «Porque has visto 6 piezas y añadiste una al carrito».
  function reasonLong(it) {
    if (!it) return '';
    var parts = [];
    if (it.bought) parts.push('ya compraste en esta categoría');
    if (it.a) parts.push(it.a === 1 ? 'añadiste una pieza al carrito' : 'añadiste ' + it.a + ' piezas al carrito');
    if (it.v) parts.push('has visto ' + it.v + (it.v === 1 ? ' pieza' : ' piezas'));
    if (it.c) parts.push(it.c === 1 ? 'entraste en la colección' : 'entraste ' + it.c + ' veces en la colección');
    if (it.q) parts.push(it.q === 1 ? 'buscaste algo relacionado' : 'buscaste algo relacionado ' + it.q + ' veces');
    return parts.length ? 'Porque ' + joinWords(parts) : '';
  }
  function reasonShort(it) {
    if (!it) return '';
    if (it.bought) return 'Ya compraste aquí';
    if (it.a) return 'En tu carrito';
    if (it.v > 1) return it.v + ' vistos';
    if (it.v === 1) return 'Lo has visto';
    if (it.q) return 'Lo buscaste';
    if (it.c) return 'Lo visitaste';
    return 'Te interesa';
  }

  function joinNames(list) {
    var names = list.map(function (it) { return it.title.toLowerCase(); });
    if (names.length < 2) return names.join('');
    return names.slice(0, -1).join(', ') + ' y ' + names[names.length - 1];
  }

  function init(root) {
    if (root.getAttribute('data-pt-ready')) return;
    root.setAttribute('data-pt-ready', '1');
    var cfgEl = root.querySelector('[data-pt-config]');
    if (!cfgEl) return;
    var cfg = JSON.parse(cfgEl.textContent);
    var base = cfg.root.replace(/\/?$/, '/');
    var collectionsBase = cfg.collectionsUrl.replace(/\/$/, '');
    var bought = cfg.bought || [];
    var viewed = readViewed();
    var rows = {};
    root.querySelectorAll('.pt-rows [data-pt-row]').forEach(function (row) {
      var key = row.getAttribute('data-pt-row');
      (rows[key] = rows[key] || []).push(row);
    });
    var images = {};
    (cfg.images || []).forEach(function (raw) {
      var p = raw.split('|');
      if (p[0] && p[1]) images[p[0]] = p[1];
    });

    function recUrl(id) {
      return base + 'recommendations/products?product_id=' + encodeURIComponent(id) + '&limit=8&intent=related';
    }
    function collectionUrl(handle) {
      return collectionsBase + '/' + encodeURIComponent(handle);
    }
    function newestUrl(handle) {
      return collectionUrl(handle) + '?sort_by=created-descending';
    }
    function onPage() {
      return Array.prototype.map.call(root.querySelectorAll('.pt-block:not([hidden]) .pt-card[data-product-id]'), function (c) {
        return c.getAttribute('data-product-id');
      });
    }
    function parseInterest(raw) {
      if (!raw) return null;
      var p = raw.split('|');
      if (!p[0]) return null;
      return { handle: p[0], title: p[1] || p[0], img: images[p[0]] || p[2] || '' };
    }
    function sized(url, w) {
      return url ? url.replace(/width=\d+/, 'width=' + w) : url;
    }

    // 1. Según sus pedidos
    if (rows.orders && cfg.seeds && cfg.seeds.length) {
      var rowO = rows.orders[0];
      showSkeleton(rowO);
      inBatches(cfg.seeds.map(recUrl), 3).then(function (lists) {
        fill(rowO, uniqueCards(interleave(lists), bought, 12));
      });
    }

    // 2. Novedades de sus marcas
    (rows.vendor || []).forEach(function (row) {
      showSkeleton(row);
      fetchCards(base + 'collections/vendors?q=' + encodeURIComponent(row.getAttribute('data-vendor')) + '&sort_by=created-descending').then(function (cards) {
        fill(row, uniqueCards([cards], bought, 12));
      });
    });

    // 3. Lo que ha mirado (base de casi todo lo demás)
    var rowV = rows.viewed && rows.viewed[0];
    var rowS = rows.similar && rows.similar[0];
    var rowM = rows.mix && rows.mix[0];
    if (viewed.length) {
      if (rowV) showSkeleton(rowV);
      if (rowS) showSkeleton(rowS);
    }
    if (rowM) showSkeleton(rowM);
    var viewedJob = viewed.length
      ? inBatches(viewed.map(function (h) { return base + 'products/' + encodeURIComponent(h); }), 3).then(function (lists) {
          return uniqueCards(lists, [], 12);
        })
      : Promise.resolve([]);

    var similarJob = viewedJob.then(function (cards) {
      var ids = cards.map(function (c) { return c.getAttribute('data-product-id'); });
      if (!ids.length) return [];
      return inBatches(ids.slice(0, 2).map(recUrl), 2).then(function (recLists) {
        return uniqueCards(interleave(recLists), ids.concat(bought), 12);
      });
    });

    viewedJob.then(function (cards) {
      if (cards[0]) renderLastViewed(cards[0]);
      if (rowV) fill(rowV, cards.map(function (c) { return c.cloneNode(true); }));
    });
    Promise.all([viewedJob, similarJob]).then(function (r) {
      if (!rowS) return;
      var first = r[0][0] && r[0][0].querySelector('.pt-card__title');
      if (first) setDesc(rowS, 'Porque has mirado «' + first.textContent.trim() + '». Opciones con un estilo parecido.');
      fill(rowS, r[1].map(function (c) { return c.cloneNode(true); }));
    });

    function renderLastViewed(card) {
      var tile = root.querySelector('[data-pt-last]');
      if (!tile) return;
      var link = card.querySelector('.pt-card__link');
      var img = card.querySelector('img');
      var title = card.querySelector('.pt-card__title');
      var price = card.querySelector('.pt-card__now');
      if (link) tile.href = link.getAttribute('href');
      if (title) tile.querySelector('[data-pt-last-title]').textContent = title.textContent.trim();
      tile.querySelector('[data-pt-last-meta]').textContent = price ? 'Lo miraste hace poco · ' + price.textContent.trim() : 'Lo miraste hace poco';
      if (img) {
        var clone = new Image(160, 200);
        clone.alt = '';
        clone.src = img.getAttribute('src');
        tile.querySelector('[data-pt-last-img]').replaceChildren(clone);
        tile.classList.add('has-img');
      }
    }

    // 4. Intereses con peso: compras (Liquid) + actividad registrada en este navegador
    //    (fichas, colecciones, búsquedas y carrito, con caducidad) + categorías de lo visto.
    //    Sin datos → colecciones de respaldo.
    var interestsJob = viewedJob.then(function (cards) {
      var byHandle = {};
      function add(raw, score, extra) {
        var it = parseInterest(raw);
        if (!it) return;
        var cur = byHandle[it.handle] || { handle: it.handle, title: it.title, img: it.img, score: 0, v: 0, c: 0, q: 0, a: 0, bought: false };
        if (!cur.img && it.img) cur.img = it.img;
        cur.score += score;
        if (extra) {
          ['v', 'c', 'q', 'a'].forEach(function (k) { cur[k] += extra[k] || 0; });
          if (extra.bought) cur.bought = true;
        }
        byHandle[it.handle] = cur;
      }
      (cfg.interests || []).forEach(function (raw) { add(raw, 5, { bought: true }); });
      var stored = readInterests();
      Object.keys(stored).forEach(function (h) {
        var s = stored[h];
        var days = (Date.now() - (s.ts || 0)) / 864e5;
        var score = (s.s || 0) * Math.pow(0.5, days / 14);
        add(h + '|' + (s.t || h) + '|' + (s.i || ''), score, s);
      });
      cards.forEach(function (c) { add(c.getAttribute('data-interest'), 0.3); });
      var personal = Object.keys(byHandle)
        .map(function (h) { return byHandle[h]; })
        .filter(function (it) { return it.score >= 0.3; })
        .sort(function (a, b) { return b.score - a.score; })
        .slice(0, 4);
      var seen = {};
      personal.forEach(function (it) { seen[it.handle] = true; });
      var fallback = (cfg.fallback || []).map(parseInterest).filter(function (it) { return it && !seen[it.handle]; });
      return { personal: personal, fallback: fallback };
    });

    // 4b. Búsquedas del cliente: «Porque buscaste …»
    var searches = readList('kayuri:searches').slice(0, 3);
    var searchJob = Promise.all(
      searches.map(function (term) {
        return fetchCards(base + 'search?type=product&q=' + encodeURIComponent(term));
      })
    );
    var rowQ = rows.search && rows.search[0];
    if (rowQ && searches.length) {
      showSkeleton(rowQ);
      var titleEl = rowQ.querySelector('.pt-head__title');
      titleEl.textContent = (titleEl.textContent || '').replace('[busqueda]', searches[0]);
      searchJob.then(function (lists) {
        if (searches.length > 1) setDesc(rowQ, 'También tenemos en cuenta lo que buscaste después: «' + searches.slice(1).join('», «') + '».');
        fill(rowQ, uniqueCards(interleave(lists), bought, 12));
      });
    }

    interestsJob.then(function (data) {
      var personal = data.personal;
      var fallback = data.fallback;
      renderFeature(personal[0]);
      renderRadar(personal);
      renderSpaces(personal, fallback);
      renderBlog(personal);
      var splitJob = renderSplits(personal.length ? personal : fallback, personal.length > 0);
      var mixJob = renderMix(personal);
      return Promise.all([splitJob, mixJob]);
    }).then(function () {
      // 5. Siempre: lo más vendido y lo recién llegado, sin repetir lo que ya se ve.
      var newEl = root.querySelector('[data-pt-new-collection]');
      var newHandle = newEl ? newEl.getAttribute('data-pt-new-collection') : 'all';
      [['best', base + 'collections/all?sort_by=best-selling'], ['new', newestUrl(newHandle)]].forEach(function (pair) {
        var row = rows[pair[0]] && rows[pair[0]][0];
        if (!row) return;
        showSkeleton(row);
        fetchCards(pair[1]).then(function (cards) {
          fill(row, uniqueCards([cards], bought.concat(onPage()), 12));
        });
      });
    });

    // «Tu radar»: sus intereses con foto, motivo y fuerza relativa.
    function renderRadar(personal) {
      var box = root.querySelector('[data-pt-radar]');
      if (!box || !personal.length) return;
      var list = box.querySelector('[data-pt-radar-list]');
      var top = personal[0].score || 1;
      var items = personal.map(function (it, i) {
        var li = document.createElement('li');
        li.className = 'pt-radar__item';
        var a = document.createElement('a');
        a.href = collectionUrl(it.handle);
        var thumb = document.createElement('span');
        thumb.className = 'pt-radar__thumb';
        if (it.img) {
          var img = new Image(96, 96);
          img.alt = '';
          img.src = sized(it.img, 200);
          thumb.appendChild(img);
        }
        var text = document.createElement('span');
        text.className = 'pt-radar__text';
        var name = document.createElement('span');
        name.className = 'pt-radar__name';
        name.textContent = it.title;
        var why = document.createElement('span');
        why.className = 'pt-radar__why';
        why.textContent = reasonShort(it);
        var meter = document.createElement('span');
        meter.className = 'pt-radar__meter';
        meter.style.setProperty('--pt-level', Math.max(0.15, Math.min(1, (it.score || 0) / top)).toFixed(2));
        meter.setAttribute('aria-hidden', 'true');
        text.append(name, why, meter);
        a.append(thumb, text);
        li.appendChild(a);
        li.style.setProperty('--i', i);
        return li;
      });
      list.replaceChildren.apply(list, items);
      box.hidden = false;
    }

    function renderFeature(it) {
      var el = root.querySelector('[data-pt-feature]');
      if (!el || !it || !it.img) return;
      el.href = collectionUrl(it.handle);
      var img = new Image(1200, 900);
      img.alt = '';
      img.src = sized(it.img, 1200);
      el.querySelector('.pt-feature__media').replaceChildren(img);
      el.querySelector('.pt-feature__title').textContent = it.title;
      var kicker = el.querySelector('[data-pt-feature-kicker]');
      if (kicker) kicker.textContent = 'Elegido para ti · ' + reasonShort(it);
      el.hidden = false;
    }

    function renderSpaces(personal, fallback) {
      var box = root.querySelector('[data-pt-spaces]');
      if (!box) return;
      var grid = box.querySelector('[data-pt-spaces-grid]');
      var max = Number(box.getAttribute('data-max')) || 4;
      var list = personal.concat(fallback).filter(function (it) { return it.img; }).slice(0, max);
      if (list.length < 2) return;
      if (!personal.length) {
        var t = box.querySelector('[data-pt-spaces-title]');
        var d = box.querySelector('[data-pt-spaces-desc]');
        if (t.getAttribute('data-fallback')) t.textContent = t.getAttribute('data-fallback');
        if (d.getAttribute('data-fallback')) d.textContent = d.getAttribute('data-fallback');
      }
      var personalByHandle = {};
      personal.forEach(function (it) { personalByHandle[it.handle] = it; });
      var tiles = list.map(function (it, i) {
        var a = document.createElement('a');
        a.className = 'pt-space';
        a.href = collectionUrl(it.handle);
        var media = document.createElement('span');
        media.className = 'pt-space__media';
        var img = new Image(700, 525);
        img.alt = '';
        img.loading = 'lazy';
        img.src = sized(it.img, i === 0 ? 1100 : 700);
        media.appendChild(img);
        if (personalByHandle[it.handle]) {
          var tag = document.createElement('span');
          tag.className = 'pt-space__tag';
          tag.textContent = reasonShort(personalByHandle[it.handle]);
          media.appendChild(tag);
        }
        var label = document.createElement('span');
        label.className = 'pt-space__title';
        label.innerHTML = '<span></span><span class="pt-space__arrow" aria-hidden="true">→</span>';
        label.firstChild.textContent = it.title;
        a.append(media, label);
        return a;
      });
      animateIn(tiles);
      grid.replaceChildren.apply(grid, tiles);
      box.hidden = false;
    }

    function renderSplits(list, isPersonal) {
      var slot = root.querySelector('[data-pt-interest-slot]');
      var tpl = root.querySelector('[data-pt-split-template]');
      if (!slot || !tpl || !list.length) return Promise.resolve();
      var count = Number(slot.getAttribute('data-count')) || 2;
      var titleTpl = slot.getAttribute('data-title') || '[categoria]';
      var descTpl = isPersonal ? slot.getAttribute('data-desc') : slot.getAttribute('data-desc-fallback');
      return Promise.all(
        list.slice(0, count).map(function (it, i) {
          var block = tpl.content.firstElementChild.cloneNode(true);
          if (i % 2 === 1) block.classList.add('pt-split--reverse');
          var url = collectionUrl(it.handle);
          block.querySelector('.pt-split__media').href = url;
          block.querySelector('.pt-row__all').href = url;
          var img = block.querySelector('.pt-split__media img');
          if (it.img) img.src = sized(it.img, 1000);
          else img.remove();
          block.querySelector('.pt-split__badge').textContent = isPersonal ? 'Elegido para ti' : 'Para inspirarte';
          block.querySelector('.pt-head__title').textContent = titleTpl.replace('[categoria]', it.title);
          var why = isPersonal ? reasonLong(it) : '';
          // Con actividad real se explica el motivo; si no, el texto del editor.
          block.querySelector('.pt-head__desc').textContent = why
            ? why + '. Aquí tienes lo último que ha llegado de ' + it.title.toLowerCase() + ', con sus precios outlet.'
            : (descTpl || '').replace('[categoria]', it.title.toLowerCase());
          if (why) {
            var pill = document.createElement('span');
            pill.className = 'pt-reason';
            pill.textContent = reasonShort(it);
            block.querySelector('.pt-head__text').prepend(pill);
          }
          var grid = block.querySelector('.pt-split__grid');
          grid.replaceChildren(skeletons(4));
          block.hidden = false;
          slot.appendChild(block);
          return fetchCards(newestUrl(it.handle)).then(function (cards) {
            var picks = uniqueCards([cards], bought, 4);
            if (!picks.length) {
              block.hidden = true;
              return;
            }
            animateIn(picks);
            grid.replaceChildren.apply(grid, picks);
          });
        })
      );
    }

    // Carrusel mezclado: lo que ha mirado + novedades de sus intereses + parecidos.
    function renderMix(personal) {
      if (!rowM) return Promise.resolve();
      var interestUrls = personal.slice(0, 3).map(function (it) { return newestUrl(it.handle); });
      return Promise.all([viewedJob, similarJob, inBatches(interestUrls, 3), searchJob]).then(function (r) {
        var lists = [r[0], r[1]].concat(r[2], r[3]);
        var cards = uniqueCards(interleave(lists), bought, 16).map(function (c) { return c.cloneNode(true); });
        if (cards.length && personal.length) {
          var topWhy = reasonLong(personal[0]);
          setDesc(
            rowM,
            'Mezclamos lo que has mirado' + (searches.length ? ', lo que has buscado' : '') + ' y novedades de ' + joinNames(personal.slice(0, 3)) + '.' +
              (topWhy ? ' Tu interés más fuerte ahora es ' + personal[0].title.toLowerCase() + ': ' + topWhy.charAt(0).toLowerCase() + topWhy.slice(1) + '.' : '')
          );
        }
        fill(rowM, cards);
      });
    }

    // Blog: artículos ordenados por coincidencia con sus intereses.
    function renderBlog(personal) {
      var box = root.querySelector('[data-pt-blog]');
      if (!box) return;
      var data;
      try {
        data = JSON.parse(box.querySelector('[data-pt-articles]').textContent);
      } catch (e) {
        return;
      }
      var max = Number(box.getAttribute('data-max')) || 3;
      var keys = personal.map(function (it) { return { it: it, words: stems(it.title) }; });
      var scored = data.map(function (a, i) {
        var hay = norm(a.k);
        var match = null;
        var score = 0;
        keys.forEach(function (k) {
          var hits = k.words.filter(function (w) { return hay.indexOf(w) > -1; }).length;
          if (hits > score) {
            score = hits;
            match = k.it;
          }
        });
        return { a: a, i: i, score: score, match: match };
      });
      scored.sort(function (x, y) { return y.score - x.score || x.i - y.i; });
      var picks = scored.slice(0, max);
      var matched = picks.filter(function (p) { return p.match; }).map(function (p) { return p.match; });
      var desc = box.querySelector('[data-pt-blog-desc]');
      if (matched.length) {
        var uniq = matched.filter(function (m, i) { return matched.indexOf(m) === i; });
        desc.textContent = desc.textContent.replace('[intereses]', joinNames(uniq));
      } else {
        desc.textContent = desc.getAttribute('data-fallback') || '';
      }
      var grid = box.querySelector('[data-pt-blog-grid]');
      var nodes = picks.map(function (p) {
        var a = document.createElement('a');
        a.className = 'pt-post';
        a.href = p.a.u;
        var media = document.createElement('span');
        media.className = 'pt-post__media';
        if (p.a.i) {
          var img = new Image(900, 600);
          img.alt = '';
          img.loading = 'lazy';
          img.src = p.a.i;
          media.appendChild(img);
        }
        if (p.match) {
          var tag = document.createElement('span');
          tag.className = 'pt-post__tag';
          tag.textContent = 'Por tu interés en ' + p.match.title.toLowerCase();
          media.appendChild(tag);
        }
        var title = document.createElement('span');
        title.className = 'pt-post__title';
        title.textContent = p.a.t;
        var ex = document.createElement('span');
        ex.className = 'pt-post__excerpt';
        ex.textContent = p.a.e;
        var cta = document.createElement('span');
        cta.className = 'pt-post__cta';
        cta.innerHTML = 'Leer artículo <span aria-hidden="true">→</span>';
        a.append(media, title, ex, cta);
        return a;
      });
      animateIn(nodes);
      grid.replaceChildren.apply(grid, nodes);
      box.hidden = false;
    }
  }

  function reveal(root) {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.classList.add('pt--reveal');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    var watch = function () {
      root.querySelectorAll('.pt-block:not(.is-visible)').forEach(function (b) { io.observe(b); });
    };
    watch();
    new MutationObserver(watch).observe(root.querySelector('.pt-rows') || root, { childList: true, subtree: false });
    var slot = root.querySelector('[data-pt-interest-slot]');
    if (slot) new MutationObserver(watch).observe(slot, { childList: true });
  }

  function start() {
    document.querySelectorAll('[data-pt]').forEach(function (root) {
      var fresh = !root.getAttribute('data-pt-ready');
      init(root);
      if (fresh) reveal(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
